// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_HistoricoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /rede/historico/:franquia_id , POST /rede/situacao e POST /rede/pasta — a situação, o histórico e a pasta da unidade. */
import type { Rede_SituacaoRow } from './Rede_SituacaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Rede_HistoricoResponseDados {
franquia_id: number
nome: string
situacao: string
situacao_registrada: boolean
historico: Rede_SituacaoRow[]
pasta_drive_url?: string
}

export type Rede_HistoricoResponse = ApiResponse<Rede_HistoricoResponseDados>;

registerResponseContract('Rede_HistoricoResponse', {
  franquia_id:         { type: 'number',  required: true },
  nome:                { type: 'string',  required: true },
  situacao:            { type: 'string',  required: true },
  situacao_registrada: { type: 'boolean', required: true },
  historico: {
    type: 'array',
    required: true,
    items: {
      id:            { type: 'number',  required: true },
      situacao:      { type: 'string',  required: true },
      desde:         { type: 'string',  required: true },
      observacao:    { type: 'string',  required: false },
      autor:         { type: 'string',  required: false },
      registrado_em: { type: 'string',  required: true },
    },
  },
  pasta_drive_url:     { type: 'string',  required: false },
})
